import { useEffect, useState, FC } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { fetchPublicQuiltWithMemorial } from 'api/http-client/queries/quiltQueries';
import { httpMessages } from 'utilities/constants';
import { useTranslates } from 'providers/translates';
import { setEditableQuiltState } from 'store/reducers/quiltSlice';
import { setOpen } from 'store/reducers/notifySlice';
import { useAppDispatch, useAppSelector, useRedirectAndScroll } from 'hooks';
import { DialogBlocks } from 'components/CreateMemorialQuiltComponents/DialogBlocks';
import { BlockModel } from 'components/CreateMemorialQuiltComponents/CreateMemorialQuiltStepThree/model';
import { Loader } from 'components/Loader/Loader';
import { AccessPermissionsTextEnum } from 'components/CreateMemorialQuiltComponents/CreateMemorialQuiltStepTwo/const';
import { CustomShareButtons } from 'components/CustomShareButtons/CustomShareButtons';
import { useAuth } from 'providers/auth-provider';
// import { Helmet } from 'react-helmet-async';
 
const QuiltView: FC = () => {
  const { id } = useParams();
  const { translates } = useTranslates();
  const dispatch = useAppDispatch();
  const editableQuilt = useAppSelector((state) => state.quilt.editableQuilt);
  const { isAuthorized } = useAuth();
  const { onlyRedirect } = useRedirectAndScroll({});
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState<string | null>(null);
  const [blocks, setBlocks] = useState<BlockModel[]>([]);
  const [editButtonStatus, setEditButtonStatus] = useState<AccessPermissionsTextEnum>(
    AccessPermissionsTextEnum.NO_EDIT
  );

  useEffect(() => {
    if (searchParams.get('isApprove') === 'true') {
      !isAuthorized && onlyRedirect(`/login?quiltId=${id}`);
    }

    if (!id) return;
    setLoading(true);
    
    fetchPublicQuiltWithMemorial(id)
      .then((response) => {
        if (response.data.success) {
          setLoading(false);

          const returned = response.data.returned;

          if (returned?.isOwner) {
            setEditButtonStatus(AccessPermissionsTextEnum.EDIT_IMAGES_MEMORIAL);
          } else if (returned?.isContributor) {
            const status = returned.accessMode === AccessPermissionsTextEnum.EDIT_IMAGES_MEMORIAL
              ? AccessPermissionsTextEnum.EDIT_IMAGES_MEMORIAL
              : AccessPermissionsTextEnum.EDIT_IMAGES;
            setEditButtonStatus(status);
          } else {
            setEditButtonStatus(AccessPermissionsTextEnum.NO_EDIT);
          }
          
          dispatch(setEditableQuiltState(response.data.returned));

          if (response.data.returned?.memorial?.data) {
            const blockData = JSON.parse(response.data.returned?.memorial?.data);
            if (Array.isArray(blockData)) {
              setBlocks(blockData);
            }
          }
        } else {
          dispatch(setOpen(`No quilt found`));
        }
      })
      .catch(() =>
        setFetchError(
          translates?.httpMessages?.fetchPublicQuiltWithMemorialError ||
            httpMessages.fetchPublicQuiltWithMemorialError
        )
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, translates?.httpMessages?.fetchPublicQuiltWithMemorialError]);

  useEffect(() => {
    return () => {
      dispatch(setEditableQuiltState({}));
    };
  }, [dispatch]);

  if (fetchError) return <div style={{ textAlign: 'center', marginTop: '50px' }}>{fetchError}</div>;

  return (
    <>
      {/* {editableQuilt.isPublished && (
        <Helmet>
          <meta property="og:title" content={`Visit ${editableQuilt.firstName} ${editableQuilt.lastName} Memorial Website`} />
          <meta property="og:description" content="Visit Memorial Website" />
          <meta property="og:image" content={editableQuilt.finalImage?.full ?? ''} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="website" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`Visit ${editableQuilt.firstName} ${editableQuilt.lastName} Memorial Website`} />
          <meta name="twitter:description" content="Visit Memorial Website" />
          <meta name="twitter:image" content={editableQuilt.finalImage?.full ?? ''} />
          <meta name="twitter:url" content={window.location.href} />
        </Helmet>
      )} */}
      <DialogBlocks
        isTributes={editableQuilt?.isEnableTributesAndCondolence}
        isViewPage={true}
        blocksProps={blocks}
        editButtonStatus={editButtonStatus}
      />
      {editableQuilt.isPublished && <CustomShareButtons />}
      <Loader loading={loading} />
    </>
  );
};

export default QuiltView;
